export const APP_TITLE = "APP_TITLE";
export const THEME = "THEME";
export const LANG = 'LANG';

export const IS_MOBILE = "IS_MOBILE";
export const INIT_LANGUAGE_CHANGE = "INIT_LANGUAGE_CHANGE";

export const SET_COUNTER = "SET_COUNTER";
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';

export const THEME_CHANGE = "THEME_CHANGE";
export const SET_BREADCRUMB = "SET_BREADCRUMB";